import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import React from 'react';

interface ConfirmationDialogProps {
  title: string;
  message: string | React.ReactNode;
  confirmLabel?: string;
  close: () => void;
  confirm: () => void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  title,
  message,
  confirmLabel,
  close,
  confirm,
}) => (
  <Dialog open onClose={close} onClick={(e) => e.stopPropagation()}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      {typeof message === 'string' ? (
        <Typography variant="body1" gutterBottom>
          {message}
        </Typography>
      ) : (
        message
      )}
    </DialogContent>
    <DialogActions>
      <Button variant="outlined" onClick={close}>
        Cancel
      </Button>
      <Button onClick={confirm} variant="contained" color="primary">
        {confirmLabel || 'Confirm'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmationDialog;
